<template>
  <div class="container">
    <div class="news">
      <div class="news-body">
        <div class="news-body-tab">
          <ul class="news-bt-ul">
            <li
              :class="[`news-bt-li`,tabIndex == i ? `news-bt-li-active`: ``]"
              v-for="(s,i) in tab"
              :key="i"
              @click="navgoTo(s,i)"
              ref="tabItem"
            >{{s.title}}</li>
          </ul>
        </div>

        <div class="news-body-view">
          <div class="news-body-centent">
            <ul class="news-body-item-views">
              <li class="news-body-item-v" v-for="(s,i) in list" :key="i">
                <div class="news-body-item-content">
                  <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div>
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
            <lPages total="990" pageSize="10" :currPage="1"></lPages>
          </div>
          <div>
            <div class="news-body-list">
              <div class="news-body-list-v">
                <h3 class="news-body-list-h3">热门推荐</h3>
                <ul class="news-body-item-view">
                  <li
                    class="news-body-item"
                    v-for="(s,i) in hot"
                    :key="i"
                    @click="navgoTo(s)"
                  >{{s.title}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lPages from "../../components/l-pages/l-pages.vue";
export default {
  components: {
    lPages
  },
  name: "ShowNews",
  data() {
    return {
      showLsit: true, //判断是否显示
      list: [
        {
          title: "播聘，为人才的价值提供无限可能",
          froms: "播聘",
          date: "2019年9月12日",
          img: ".../../../static/Bitmap_1.png",
          content:
            "受“贸易战”、“行业洗牌”、“生活方式变化”“人力资源成本增加”等因素影响，从2018年下半年开始，我们时常听到裁员、减薪等消息，在经济下行的情况下，许多行业对于员工、岗位的匹配度、精准度、效率等需求越来越强。如何让企业快速招到合适的人才，如何让求职者用最短的时间找到满意的工作，如何降低供需双方在签约入职的过程中所消耗的大量成本，从而提高生产效率。这是很多招聘平台在思考的问题。",
          path: "/show-news-detail"
        },
        {
          title: "一个35岁的职场老鸟给你提个醒：千万不要试图去感动你的领导",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static//Bitmap_2.jpg",
          content:
            "职场上，老板只认“功劳”不认“苦劳”，想用自己的努力去感动老板，真的不可能...",
          path: "/show-message"
        },
        {
          title: "13个高效沟通技巧助你成为HR沟通高手",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static//Bitmap_3.jpg",
          content:
            "高效的沟通技巧是一个HR高手必备的技能，本期播聘工作技巧带你晋级，13个高效沟通技巧干货请收下...",
          path: "/show-acrobatics"
        },
        {
          title: "这十个职场小故事，让我受益一生",
          froms: "播聘",
          date: "2019年9月19日",
          img: ".../../../static//Bitmap_4.jpg",
          content:
            "职场是每一个人必然要经历的人生阶段，职场的成功与失败，取决于一个人的知识、能力、经验和素质...",
          path: "/show-story"
        }
      ],
      tab: [
        {
          title: "全部"
        },
        {
          title: "播聘新闻"
        },
        {
          title: "职场资讯",
          path:'/show-bopin-news'
        },
        
        {
          title: "职场故事"
        }
      ],
      tabIndex: 0,
      hot: [
        {
          title: "【播聘新闻 】推动行业高速发展，推动行业高速发展",
          path: "/show-news-detail"
        },
        {
          title:
            "【职场资讯 】一个35岁的职场老鸟给你提个醒：千万不要试图去感动你的领导",
          path: "/show-message"
        },
        {
          title: "【工作技巧 】13个高效沟通技巧助你成为HR沟通高手",
          path: "/show-acrobatics"
        },
        {
          title: "【职场故事 】这十个职场小故事，让我受益一生",
          path: "/show-story"
        }
      ],
      currPage: 5
    };
  },
  methods: {
    changeTab(s, i) {
      console.log(s);
      // if (i === 1) {
      // } else if (i === 2) {
      //   this.$router.push("/show-news/show-bopin-news");
      // } else if (i === 3) {
      // }
      this.tabIndex = i;
      console.log(i);
      // document.documentElement.scrollTop = 495 * (i - 1);
      console.log(document.documentElement.scrollTop);
    },
    navgoTo(s) {
      this.$nav({ path: s.path }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./show-news.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-news/show-bopin-news.vue